(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["parfumetics-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-collection-navigation')) {
    customElements.define('pf-collection-navigation', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.viewport = this.querySelector('[data-pf-viewport]');
        this.thumb = this.querySelector('[data-pf-thumb]');
        if (!this.viewport || !this.thumb) return;
        this.update = () => {
          const viewport = this.viewport;
          const track = this.thumb.parentElement;
          const maxScroll = viewport.scrollWidth - viewport.clientWidth;
          track.style.opacity = maxScroll > 1 ? '1' : '0';
          const width = track.clientWidth;
          if (maxScroll <= 1 || width === 0) return;
          const thumbWidth = Math.min(width, Math.max(24, viewport.clientWidth / viewport.scrollWidth * width));
          const position = Math.min(1, Math.max(0, Math.abs(viewport.scrollLeft) / maxScroll));
          const rtl = getComputedStyle(viewport).direction === 'rtl';
          this.thumb.style.width = `${thumbWidth}px`;
          this.thumb.style.transform = `translateX(${(rtl ? 1 - position : position) * (width - thumbWidth)}px)`;
        };
        this.viewport.addEventListener('scroll', this.update, { passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
        this.observer.observe(this.viewport.firstElementChild);
        this.observer.observe(this.thumb.parentElement);
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.viewport?.removeEventListener('scroll', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parfumetics-product-grid"] && !Shopify.designMode) return;
  try {
    
class PfFragranceFilters {
  static matches(product, selections, excluded = '') {
    return Object.entries(selections).every(([group, values]) => {
      if (group === excluded || !values.length) return true;
      if (group === 'rating') return product.reviewCount > 0 && values.some(value => product.rating >= Number(value));
      if (group === 'available') return product.available;
      return values.some(value => product[group]?.includes(value));
    });
  }
  constructor(grid, signal) {
    this.grid = grid;
    this.dialog = grid.querySelector('[data-facet-dialog]');
    this.opener = grid.querySelector('[data-facet-open]');
    this.labels = JSON.parse(grid.querySelector('[data-facet-labels]').textContent);
    this.products = Array.from(grid.querySelectorAll('.pfpg__item')).map(card => ({
      card, gender: [card.dataset.facetGender].filter(Boolean),
      character: JSON.parse(card.dataset.facetCharacter || '[]').map(value => value.trim()).filter(Boolean),
      moment: JSON.parse(card.dataset.facetMoment || '[]'),
      available: card.dataset.facetAvailable === 'true',
      rating: Number(card.dataset.reviewScore) / 20 || 0,
      reviewCount: Number(card.dataset.reviewCount) || 0
    }));
    this.groups = ['gender', 'character', 'moment', 'rating', 'available'];
    this.options = {};
    this.applied = {};
    const params = new URL(location.href).searchParams;
    for (const group of this.groups) {
      let values;
      if (group === 'rating') values = ['4.5','4.8'].filter(value => this.products.some(p => p.reviewCount > 0 && p.rating >= Number(value)));
      else if (group === 'available') values = this.products.some(p => p.available) && this.products.some(p => !p.available) ? ['in-stock'] : [];
      else values = [...new Set(this.products.flatMap(p => p[group]))].sort((a,b)=>a.localeCompare(b));
      if (group === 'gender') values.sort((a,b)=>['Mannen','Vrouwen','Unisex'].indexOf(a)-['Mannen','Vrouwen','Unisex'].indexOf(b));
      if (group !== 'rating' && group !== 'available' && values.length < 2) values = [];
      this.options[group] = values;
      this.applied[group] = params.getAll('pf_' + group).filter(value => values.includes(value));
    }
    this.draft = structuredClone(this.applied);
    this.buildGroups();
    const listen = (node, type, handler) => node.addEventListener(type, handler, {signal});
    listen(this.opener, 'click', () => {
      this.draft = structuredClone(this.applied);
      this.syncInputs();
      this.updateCounts();
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
    });
    listen(this.dialog, 'close', () => { document.body.style.overflow = this.previousOverflow ?? ''; });
    listen(this.dialog, 'click', event => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    });
    listen(this.dialog.querySelector('[data-facet-close]'), 'click', () => this.dialog.close());
    listen(this.dialog.querySelector('[data-facet-clear]'), 'click', () => {
      for (const group of this.groups) this.draft[group] = [];
      this.syncInputs(); this.updateCounts();
    });
    listen(this.dialog.querySelector('[data-facet-apply]'), 'click', () => {
      this.applied = structuredClone(this.draft); this.apply(); this.dialog.close();
    });
    listen(this.dialog, 'change', event => {
      const input = event.target;
      const group = input.dataset.facetGroup;
      if (!group) return;
      if (group === 'rating') {
        this.draft.rating = input.checked ? [input.value] : [];
        this.syncInputs();
      } else this.draft[group] = [...this.dialog.querySelectorAll('input[data-facet-group="' + group + '"]:checked')].map(node => node.value);
      this.updateCounts();
    });
    listen(grid.querySelector('[data-facet-chips]'), 'click', event => {
      const button = event.target.closest('button[data-remove-group]');
      if (!button) return;
      this.applied[button.dataset.removeGroup] = this.applied[button.dataset.removeGroup].filter(value => value !== button.dataset.removeValue);
      this.apply();
    });
    const clearApplied = () => {
      for (const group of this.groups) this.applied[group] = [];
      this.apply();
    };
    listen(grid.querySelector('[data-facet-reset]'), 'click', clearApplied);
    listen(grid.querySelector('[data-facet-empty] button'), 'click', clearApplied);
    this.opener.hidden = false;
    grid.querySelector('.pfpg__filters').hidden = true;
    this.apply(false);
  }
  label(group, value) {
    if (group === 'rating') return value.replace('.', ',') + ' ' + this.labels.ratingSuffix;
    if (group === 'available') return this.labels.inStock;
    return value;
  }
  buildGroups() {
    const container = this.dialog.querySelector('[data-facet-groups]');
    container.replaceChildren();
    for (const group of this.groups) {
      if (!this.options[group].length) continue;
      const details = document.createElement('details');
      details.className = 'pfpg__facet-group';
      details.open = group === 'gender' || group === 'character';
      const summary = document.createElement('summary');
      summary.textContent = this.labels[group];
      details.appendChild(summary);
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.className = 'pfpg__sr'; legend.textContent = this.labels[group];
      fieldset.appendChild(legend);
      for (const value of this.options[group]) {
        const label = document.createElement('label'); label.className = 'pfpg__facet-option';
        const input = document.createElement('input');
        input.type = 'checkbox'; input.value = value; input.dataset.facetGroup = group;
        const name = document.createElement('span'); name.textContent = this.label(group,value);
        const count = document.createElement('span'); count.className = 'pfpg__facet-count';
        label.append(input,name,count); fieldset.appendChild(label);
      }
      details.appendChild(fieldset); container.appendChild(details);
    }
  }
  syncInputs() {
    this.dialog.querySelectorAll('input[data-facet-group]').forEach(input => {
      input.checked = this.draft[input.dataset.facetGroup].includes(input.value);
    });
  }
  updateCounts() {
    this.dialog.querySelectorAll('input[data-facet-group]').forEach(input => {
      const group = input.dataset.facetGroup;
      const count = this.products.filter(p => PfFragranceFilters.matches(p,this.draft,group)
        && PfFragranceFilters.matches(p,{[group]:[input.value]})).length;
      input.disabled = count === 0 && !input.checked;
      input.closest('label').querySelector('.pfpg__facet-count').textContent = String(count);
    });
    const count = this.products.filter(p => PfFragranceFilters.matches(p,this.draft)).length;
    this.dialog.querySelector('[data-facet-apply]').textContent = this.labels.show.replace('{count}',String(count));
    this.dialog.querySelector('[data-facet-preview]').textContent = this.labels.results.replace('{count}',String(count));
  }
  apply(updateURL = true) {
    let count = 0;
    for (const product of this.products) {
      product.card.hidden = !PfFragranceFilters.matches(product,this.applied);
      if (!product.card.hidden) count++;
    }
    const chips = this.grid.querySelector('[data-facet-chips]'); chips.replaceChildren();
    let selected = 0;
    for (const group of this.groups) for (const value of this.applied[group]) {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'pfpg__filter-chip';
      button.dataset.removeGroup = group; button.dataset.removeValue = value;
      button.setAttribute('aria-label',this.labels.remove + ': ' + this.label(group,value));
      const text = document.createElement('span'); text.textContent = this.label(group,value);
      const cross = document.createElement('span'); cross.textContent = '×'; cross.setAttribute('aria-hidden','true');
      button.append(text,cross); chips.appendChild(button); selected++;
    }
    this.grid.querySelector('[data-facet-reset]').hidden = selected === 0;
    this.grid.querySelector('[data-facet-total]').textContent = this.labels.results.replace('{count}',String(count));
    this.grid.querySelector('[data-facet-total]').hidden = false;
    this.opener.querySelector('[data-facet-selected]').textContent = selected ? ' (' + selected + ')' : '';
    this.grid.querySelector('[data-facet-empty]').hidden = count > 0;
    if (updateURL) {
      const url = new URL(location.href);
      for (const group of this.groups) {
        url.searchParams.delete('pf_' + group);
        for (const value of this.applied[group]) url.searchParams.append('pf_' + group,value);
      }
      history.replaceState(history.state,'',url);
    }
  }
  destroy() {
    if (this.dialog.open) {
      this.dialog.close(); document.body.style.overflow = this.previousOverflow ?? '';
    }
  }
}

if (!customElements.get('pf-product-grid')) {
  customElements.define('pf-product-grid', class extends HTMLElement {
    connectedCallback() {
      this.filterController?.destroy();
      this.controller?.abort();
      this.controller = new AbortController();
      this.setupVibe();
      this.setupFragranceFilters();
      this.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('.pfpg__buy-form')) return;
        event.preventDefault();
        this.addProduct(form);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.filterController?.destroy();
      this.controller?.abort();
    }
    setupFragranceFilters() {
      if (!this.querySelector('[data-facet-dialog]') || !this.querySelector('.pfpg__item') || this.querySelector('.pfpg__pagination')) return;
      this.filterController = new PfFragranceFilters(this, this.controller.signal);
    }
    setupVibe() {
      const toggle = this.querySelector('.pfpg__vibe-toggle');
      if (!toggle) return;
      toggle.hidden = false;
      let enabled = false;
      try { enabled = sessionStorage.getItem('pf-collection-vibe') === 'true'; } catch {}
      this.setVibe(enabled);
      toggle.addEventListener('click', () => {
        const value = toggle.getAttribute('aria-checked') !== 'true';
        try { sessionStorage.setItem('pf-collection-vibe', String(value)); } catch {}
        document.querySelectorAll('pf-product-grid').forEach(grid => {
          if (grid.querySelector('.pfpg__vibe-toggle') && grid.setVibe) grid.setVibe(value);
        });
      }, { signal: this.controller.signal });
    }
    setVibe(enabled) {
      this.dataset.vibe = String(enabled);
      this.querySelector('.pfpg__vibe-toggle')?.setAttribute('aria-checked', String(enabled));
      if (!enabled) return;
      this.querySelectorAll('template[data-vibe-image]').forEach(template => {
        const image = template.content.firstElementChild.cloneNode(true);
        const ready = () => { if (image.naturalWidth > 0) image.setAttribute('data-ready', ''); };
        image.addEventListener('load', ready, { once: true });
        template.replaceWith(image);
        if (image.complete) ready();
      });
    }
    async addProduct(form) {
      const button = form.querySelector('button');
      if (button.disabled) return;
      const feedback = form.closest('.pfpg__card').querySelector('.pfpg__feedback');
      const message = feedback.querySelector('span');
      const cartLink = feedback.querySelector('a');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      feedback.hidden = true;
      cartLink.hidden = true;
      let added = false;
      try {
        const data = new FormData(form);
        const response = await fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: data.get('id'), quantity: Number(data.get('quantity')) }] })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          message.textContent = typeof error.description === 'string' ? error.description : form.dataset.error;
          return;
        }
        added = true;
        message.textContent = form.dataset.added;
        cartLink.hidden = false;
        const themeApi = typeof theme !== 'undefined' ? theme : window.theme;
        if (themeApi?.cart?.fetchTotals && themeApi.cart.updateAllHtml) {
          try {
            await themeApi.cart.fetchTotals();
            const results = await themeApi.cart.updateAllHtml(true);
            const refreshed = !Array.isArray(results) || results.every(result => result.status === 'fulfilled');
            if (refreshed && themeApi.settings?.cart_type === 'drawer' && themeApi.drawer?.open && button.isConnected) {
              themeApi.drawer.open('right', 'cart-drawer', button);
            }
          } catch {
            message.textContent = form.dataset.added;
          }
        }
      } catch {
        message.textContent = added ? form.dataset.added : form.dataset.uncertain;
        cartLink.hidden = false;
      } finally {
        feedback.hidden = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-bestseller-tabs"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pf-product-grid')) {
  customElements.define('pf-product-grid', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.setupVibe();
      this.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('.pfpg__buy-form')) return;
        event.preventDefault();
        this.addProduct(form);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    setupVibe() {
      const toggle = this.querySelector('.pfpg__vibe-toggle');
      if (!toggle) return;
      toggle.hidden = false;
      let enabled = false;
      try { enabled = sessionStorage.getItem('pf-collection-vibe') === 'true'; } catch {}
      this.setVibe(enabled);
      toggle.addEventListener('click', () => {
        const value = toggle.getAttribute('aria-checked') !== 'true';
        try { sessionStorage.setItem('pf-collection-vibe', String(value)); } catch {}
        document.querySelectorAll('pf-product-grid').forEach(grid => {
          if (grid.querySelector('.pfpg__vibe-toggle') && grid.setVibe) grid.setVibe(value);
        });
      }, { signal: this.controller.signal });
    }
    setVibe(enabled) {
      this.dataset.vibe = String(enabled);
      this.querySelector('.pfpg__vibe-toggle')?.setAttribute('aria-checked', String(enabled));
      if (!enabled) return;
      this.querySelectorAll('template[data-vibe-image]').forEach(template => {
        const image = template.content.firstElementChild.cloneNode(true);
        const ready = () => { if (image.naturalWidth > 0) image.setAttribute('data-ready', ''); };
        image.addEventListener('load', ready, { once: true });
        template.replaceWith(image);
        if (image.complete) ready();
      });
    }
    async addProduct(form) {
      const button = form.querySelector('button');
      if (button.disabled) return;
      const feedback = form.closest('.pfpg__card').querySelector('.pfpg__feedback');
      const message = feedback.querySelector('span');
      const cartLink = feedback.querySelector('a');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      feedback.hidden = true;
      cartLink.hidden = true;
      let added = false;
      try {
        const data = new FormData(form);
        const response = await fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: data.get('id'), quantity: Number(data.get('quantity')) }] })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          message.textContent = typeof error.description === 'string' ? error.description : form.dataset.error;
          return;
        }
        added = true;
        message.textContent = form.dataset.added;
        cartLink.hidden = false;
        const themeApi = typeof theme !== 'undefined' ? theme : window.theme;
        if (themeApi?.cart?.fetchTotals && themeApi.cart.updateAllHtml) {
          try {
            await themeApi.cart.fetchTotals();
            const results = await themeApi.cart.updateAllHtml(true);
            const refreshed = !Array.isArray(results) || results.every(result => result.status === 'fulfilled');
            if (refreshed && themeApi.settings?.cart_type === 'drawer' && themeApi.drawer?.open && button.isConnected) {
              themeApi.drawer.open('right', 'cart-drawer', button);
            }
          } catch {
            message.textContent = form.dataset.added;
          }
        }
      } catch {
        message.textContent = added ? form.dataset.added : form.dataset.uncertain;
        cartLink.hidden = false;
      } finally {
        feedback.hidden = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}

if(!customElements.get('pf-bestseller-tabs'))customElements.define('pf-bestseller-tabs',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const tabs=[...this.querySelectorAll('[role=tab]')];const activate=(tab,focus=false)=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',active);t.tabIndex=active?0:-1;this.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active});this.querySelector('.pfbt__shop').href=tab.dataset.url;if(focus)tab.focus();};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab),{signal});tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();activate(tabs[next],true)}},{signal})});}disconnectedCallback(){this.abort?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-fragrance-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pf-fragrance-discovery')) {
  customElements.define('pf-fragrance-discovery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.arrows = this.querySelector('.pfd__arrows');
      this.arrows.hidden = false;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => { event.preventDefault(); this.select(tab.dataset.group); }, { signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); this.select(this.tabs[next].dataset.group); this.tabs[next].focus();
        }, { signal });
      });
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        const track = this.track();
        track.scrollBy({ left: track.clientWidth * .85 * Number(button.dataset.step), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal }));
      this.querySelectorAll('.pfd__track').forEach(track => track.addEventListener('scroll', () => this.updateArrows(), { passive:true, signal }));
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this);
      this.select(this.dataset.selected);
      this.editorSelect = event => {
        const card = event.target.closest('.pfd__card');
        if (!card || !this.contains(card)) return;
        const panel = card.closest('[role="tabpanel"]');
        const tab = this.tabs.find(item => item.getAttribute('aria-controls') === panel.id);
        this.select(tab.dataset.group); card.scrollIntoView({ block:'nearest', inline:'nearest' });
      };
      document.addEventListener('shopify:block:select', this.editorSelect, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); }
    track() { return this.querySelector('[role="tabpanel"]:not([hidden]) .pfd__track'); }
    select(group) {
      this.dataset.selected = group;
      this.tabs.forEach(tab => {
        const active = tab.dataset.group === group;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        this.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls'))).hidden = !active;
      });
      this.updateArrows();
    }
    updateArrows() {
      const track = this.track(); if (!track) return;
      const end = track.scrollWidth - track.clientWidth;
      this.arrows.hidden = end < 2;
      this.querySelector('[data-step="-1"]').disabled = track.scrollLeft < 2;
      this.querySelector('[data-step="1"]').disabled = track.scrollLeft >= end - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
